/* Caldore theme JS */
(function () {
  'use strict';

  /* Mobile menu */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      var nav = document.querySelector('.nav');
      if (nav) nav.classList.toggle('open');
    }
  });

  /* Product tabs (homepage featured) */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('.tab');
    var grid = wrap.querySelector('.products-grid');
    if (!grid) return;
    var items = grid.querySelectorAll('.product[data-cat]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var f = tab.dataset.filter;
        items.forEach(function (p) {
          p.style.display = (f === 'all' || p.dataset.cat === f) ? '' : 'none';
        });
      });
    });
  });

  /* Toast */
  function toast(msg) {
    var t = document.getElementById('cart-toast');
    if (!t) return;
    t.querySelector('.msg').textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; }
    var data = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body.description || 'Eroare'); }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        toast('Produs adăugat în coș');
        if (btn) { btn.innerHTML = original; btn.disabled = false; }
      })
      .catch(function (err) {
        toast(err.message || 'Stoc indisponibil');
        if (btn) { btn.innerHTML = original; btn.disabled = false; }
      });
  });

  /* Quantity stepper */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += (b.dataset.qty === 'plus' ? 1 : -1);
    if (v < 1) v = 1;
    input.value = v;
  });

  /* Product gallery thumbs */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.main-media img');
    g.querySelectorAll('.product-thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) main.src = btn.dataset.full;
        g.querySelectorAll('.product-thumbs button').forEach(function (x) { x.classList.remove('active'); });
        btn.classList.add('active');
      });
    });
  });

  /* kW picker on product page: dedupe + sort ascending */
  document.querySelectorAll('[data-kw-picker]').forEach(function (row) {
    var seen = {};
    Array.prototype.slice.call(row.querySelectorAll('.kw-pick')).forEach(function (el) {
      var k = el.dataset.kw;
      if (seen[k]) {
        if (el.classList.contains('active')) { seen[k].remove(); seen[k] = el; }
        else { el.remove(); }
      } else { seen[k] = el; }
    });
    Array.prototype.slice.call(row.querySelectorAll('.kw-pick'))
      .sort(function (a, b) { return (parseFloat(a.dataset.kw) || 0) - (parseFloat(b.dataset.kw) || 0); })
      .forEach(function (el) { row.appendChild(el); });
  });

  /* Sort by kW (client-side) on collection page */
  document.querySelectorAll('[data-kw-sort]').forEach(function (ctrl) {
    var grid = ctrl.closest('.collection-page, .container').querySelector('.products-grid');
    if (!grid) return;
    ctrl.querySelectorAll('[data-kwdir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.dataset.kwdir === 'desc' ? -1 : 1;
        ctrl.querySelectorAll('[data-kwdir]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var items = Array.prototype.slice.call(grid.querySelectorAll('.product'));
        items.sort(function (a, b) {
          var ka = parseFloat(a.dataset.kw) || 0;
          var kb = parseFloat(b.dataset.kw) || 0;
          return (ka - kb) * dir;
        });
        items.forEach(function (el) { grid.appendChild(el); });
      });
    });
  });
})();
